export enum SetupStepsEnum {
  ABOUT_YOUR_PROGRAM = "aboutYourProgram",
  ABOUT_YOUR_TOOLS = "aboutYourTools",
  ABOUT_YOUR_GOALS = "aboutYourGoals",
  CUSTOMIZE_YOUR_ACCOUNT = "customizeYourAccount",
  INVITE_YOUR_TEAM = "inviteYourTeam",
  CONGRATULATIONS = " congratulations",
}
